/**
 *  <Desription of Service here>
 *
 * @export
 * @class LocalstorageManager
 */
export class LocalStorageManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'localStorageService']
  public static SKIP_TUTORIAL_KEY: string = 'skip_tutorial'
  public static AUDIO_IS_MUTED_WW_KEY: string = 'AUDIO_IS_MUTED_WW'

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public localStorageService: any) {
    this.$log = $log.getInstance('LocalstorageManager', false)
    this.$log.debug('constructor')
  }

  public isSupported(): boolean {
    return this.localStorageService.isSupported
  }

  public set(key, val) {
    this.$log.debug('set', key, val)
    return this.localStorageService.set(key, val)
  }

  public get(key) {
    this.$log.debug('get', key, this.localStorageService.get(key))
    return this.localStorageService.get(key)
  }

  public shouldSkipTutorial(skipInFuture:boolean = false): boolean {
    if (this.isSupported()) {
      if (skipInFuture) {
        //set value
        this.localStorageService.set(LocalStorageManager.SKIP_TUTORIAL_KEY, skipInFuture)
      } else {
        //look for value
        if (this.localStorageService.get(LocalStorageManager.SKIP_TUTORIAL_KEY)) {
          return this.localStorageService.get(LocalStorageManager.SKIP_TUTORIAL_KEY)
        } else {
          return false
        }
      }
    }

  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/localstorage-manager/localstorage-manager.ts
 **/